import styled from "styled-components"

export const StyledLoginContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  color: white;
  text-align: center;
  align-items: center;
`;

export const StyledHeading = styled.h1`
  font-size: 2.8rem;
  margin-bottom: 20px;
`;

export const StyledSubHeading = styled.h2`
  font-size: 1.8rem;
  margin-bottom: 20px;
`;
